module.exports = __webpack_public_path__ + "static/media/refresh.24984dbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/refresh.svg
// module id = 895
// module chunks = 7